import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "hoverable"];
import * as React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ConfigContext } from './config-provider';
var propTypes = {
  // prefixCls: PropTypes.string,
  className: PropTypes.string,
  hoverable: PropTypes.bool,
  style: PropTypes.object
};
var defaultProps = {
  className: '',
  hoverable: false,
  style: {}
};

var Grid = function Grid(_ref) {
  var className = _ref.className,
      _ref$hoverable = _ref.hoverable,
      hoverable = _ref$hoverable === void 0 ? true : _ref$hoverable,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ConfigContext.Consumer, null, function (_ref2) {
    var getPrefixCls = _ref2.getPrefixCls;
    var prefixCls = getPrefixCls('card');
    var classString = classNames("".concat(prefixCls, "-grid"), className, _defineProperty({}, "".concat(prefixCls, "-grid-hoverable"), hoverable));
    return /*#__PURE__*/React.createElement("div", _extends({}, props, {
      className: classString
    }));
  });
};

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;
export default Grid;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-card/src/Grid.js